import { Flex, SkeletonText, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useVatDeclaration } from '../../../../context/vatDeclarationContext'

export const VatSuggestionsTitle = (): ReactElement => {
  const { t } = useTranslation()
  const { isLoading, periodText } = useVatDeclaration()

  return (
    <Flex flexDirection="column">
      <Text variant="h2">{t('copilot.page_title')}</Text>
      {isLoading ? <SkeletonText /> : <Text colorVariant="secondary">{periodText}</Text>}
    </Flex>
  )
}
